import React, { useEffect } from "react";
import "./styled.css";
//redux
import { connect } from "react-redux";
//tags
import MetaTags from "react-meta-tags";
import { setAdminPlusRankingPoints } from "../../../utils/service/ranking";

function DescompressionRoom(props) {
  function pointAction(type) {
    setAdminPlusRankingPoints(
      type,
      props.state.user.registration,
      "c90a159e-e538-43d3-a66b-82292586912f"
    );
  }

  function visitLink(e) {
    window.open(e, "_blank");
  }

  useEffect(() => {
    // document.activeElement.tabIndex = 13
    document.getElementById("title-descompression-room").focus();
    props.loadingUserOff();
  }, []);
  return (
    <section className="section-descompression-room" id="section-mainStage">
      <MetaTags>
        <title>Digital Lovers Festival - Página Sala de Descompressão</title>
      </MetaTags>
      <a id="title-descompression-room" className="title-home" tabIndex={12}>
        Página Sala de Descompressão
      </a>
      <div className="div-cards-talent">
        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Gamers
          </a>
          <iframe
            src="https://player.vimeo.com/video/806480972?h=e93689e0e9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture"
            allowfullscreen
            // style={{"position:absolute;top:0;left:0;width:100%;height:100%;"
            title="GAMER - AUDIODESCRI&amp;Ccedil;&amp;Atilde;O"
            onClick={() => pointAction("SALASDEDESCOMPRESSAOGAMERS")}
          ></iframe>
        </div>

        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Dicas DR Pet 1
          </a>
          <iframe
            title="DICAS DR PET 01 - AUDIODESCRI&amp;Ccedil;&amp;Atilde;O"
            width="100%"
            height="100%"
            src="https://player.vimeo.com/video/808344494?h=1b9cdb206d&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow={`microphone; camera; autoplay`}
            allowFullScreen
            onClick={() => pointAction("SALASDEDESCOMPRESSAOPETS")}
          />
        </div>

        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Dicas DR Pet 2
          </a>
          <iframe
            title="DICAS DR PET 02 - AUDIODESCRI&amp;Ccedil;&amp;Atilde;O"
            width="100%"
            height="100%"
            src="https://player.vimeo.com/video/810570226?h=c24fa77ccb&badge=0&autopause=0&player_id=0&app_id=58479/embed"
            frameBorder="0"
            allow={`microphone; camera; autoplay`}
            allowFullScreen
            onClick={() => pointAction("SALASDEDESCOMPRESSAOCERVEJAS")}
          />
        </div>

        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Dicas DR Pet 3
          </a>
          <iframe
            title="DICAS DR PET 03 - AUDIODESCRI&amp;Ccedil;&amp;Atilde;O"
            width="100%"
            height="100%"
            src="https://player.vimeo.com/video/810570380?h=134eb086ce&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow={`microphone; camera; autoplay`}
            allowFullScreen
            onClick={() => pointAction("SALASDEDESCOMPRESSAOBATE-PAPO")}
          />
        </div>

        <div className="card-talent">
          <a className="title-card-talent" id="title-card-talent" tabIndex={15}>
            Dr. Pet Digital Lovers
          </a>
          <iframe
            title="Dr. Pet Digital Lovers - AUDIODESCRI&amp;Ccedil;&amp;Atilde;O"
            width="100%"
            height="100%"
            src="https://player.vimeo.com/video/815314668?h=33d021c674&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
            frameBorder="0"
            allow={`microphone; camera; autoplay`}
            allowFullScreen
            onClick={() => pointAction("DRPETDIGITALLOVERS")}
          />
        </div>

      </div>
    </section>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

const mapDispatchToProps = function (dispatch) {
  return {
    loadingUserOff: (data) => {
      return dispatch({ type: "LOGIN_NAVIGATION_OFF", data });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DescompressionRoom);
